import { joiResolver } from '@hookform/resolvers/joi'
import Joi from 'joi'
import React, { Dispatch, SetStateAction, forwardRef, useImperativeHandle, useState } from 'react'
import { Button, Col, Container, Form, OverlayTrigger, Popover, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import arrowIcon from 'src/asset/image/arrow-back.svg'
import { AgreementsData } from 'src/business/model/sign-up-data'
import { PdfViewer } from 'src/component/util/pdf-viewer'

const agreementsDataSchema = Joi.object({
  termsAndConditions: Joi.boolean().valid(true).required(),
})

export const HaulierAgreementForm = forwardRef(
  (props: { onSubmit: (agreements: AgreementsData) => void }, ref): React.ReactElement => {
    const {
      register,
      handleSubmit,
      formState: { errors, isValid },
    } = useForm<AgreementsData>({
      mode: 'onChange',
      resolver: joiResolver(agreementsDataSchema),
    })

    useImperativeHandle(
      ref,
      () => {
        return {
          submit(): void {
            handleSubmit(
              (data) => isValid && props.onSubmit(data),
              // eslint-disable-next-line no-console
              (errors1) => console.log(errors1),
            )()
          },
        }
      },
      [],
    )

    const [showTermsAndConditions, setShowTermsAndConditions] = useState(false)

    const showPDF = (): void => {
      setShowTermsAndConditions(true)
    }

    return (
      <div>
        <Row className="gx-5 mb-5">
          <Col md={6}>
            <p className="font-14 color-dark-blue">Please accept our Terms and Conditions in order to proceed.</p>
          </Col>
        </Row>
        <Row className="gx-5">
          <Col md={6}>
            <Button onClick={showPDF} variant="light" className="button-round-large color-dark-blue-imp">
              Terms and Conditions
              <img className="forward-icon" src={arrowIcon} />
            </Button>
          </Col>
          {showTermsAndConditions && (
            <Col className="tac-background py-4" md={6}>
              <div className="mx-auto mb-4">
                <PdfViewer />
              </div>
              <Form>
                <Form.Check
                  type="checkbox"
                  label="I agree with terms and conditions of the master service agreement"
                  id="terms-and-conditions-checkbox"
                  {...register('termsAndConditions')}
                  isInvalid={!!errors.termsAndConditions}
                />
                {errors.termsAndConditions && (
                  <Form.Control.Feedback type="invalid">{errors.termsAndConditions.message}</Form.Control.Feedback>
                )}
              </Form>
            </Col>
          )}
        </Row>
      </div>
    )
  },
)
